import reportService from 'services/report-service';
import _ from 'lodash';

import LabworkType from "enums/labwork-type";

const defaultReport = {
  id: null,
  selectedPatient: null,
  patientFirstName: "",
  patientLastName: "",
  patientMRN: "",
  patientGender: "",
  patientBirthDate: "",
  patientEmail: "",
  labcorpNumber: "",

  type: null,
  labworkType: LabworkType.Internal,
  providerId: null,
  employerTagId: null,

  survey: {
    address: {
      address1: null,
      address2: null,
      zip: null
    },
    birthDate: null,
    gender: null,
    phoneNumber: null
  },

  hasLabcorpResult: false,
  hasReqDocument: false,
  client: {
    physicianFirstName: null,
    physicianLastName: null,
    physicianNPI: null
  },

  employee: {
    firstName: null,
    lastName: null,
    physicianNPI: null
  },

  isForUpdate: false,
}

const state = {
  report: _.cloneDeep(defaultReport)
};

const getters = {
  hasSelectedPatient: (state) => state.report.selectedPatient,
  patientName: (state) => state.report.selectedPatient ? state.report.selectedPatient.text : state.report.patientFirstName + " " + state.report.patientLastName
};

const mutations = {
  ["clear"](state) {
    state.report = _.cloneDeep(defaultReport);
  },

  ["get"](state, report) {
    state.report = report;
  },

  ["create"](state, report) {
    state.report = report;
  },

  ["update"](state, report) {
    state.report = report;
  },

  ["select-patient"](state, patient) {
    state.report.selectedPatient = patient;
  },
};

const actions = {
  clear({ commit }) {
    commit("clear");
  },

  async getById({ commit }, id) {
    commit("get", await reportService.getById(id));
  },

  async createReport({ commit, state }) {
    commit("create", await reportService.create(state.report));
  },

  async updateReport({ commit }, report) {
    if (report.isForUpdate)
      commit("update", await reportService.updateReport(report));
    else
      commit("update", report);
  },

  selectPatient({ commit }, patient) {
    commit("select-patient", patient);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};